// extracted by mini-css-extract-plugin
export default {"back-arrow":"style_back-arrow__Mj3Q3","header-style":"style_header-style__S5GmI"};